import React, { useEffect, useState } from 'react'
import "./styles.css";
import { ReactComponent as Showpassword } from "common/assets/svg/showPassword.svg";
import { ReactComponent as Hidepassword } from "common/assets/svg/hidePassword.svg";
import { CountryCodeData } from 'components/dialCodePicker';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { validateField } from 'common/utils/field-validator';
import { RootState } from 'common/rootReducer';
import { resetPasswordRequest } from 'common/features/auth/AuthActions';
import { ResetPassword } from 'common/features/auth/AuthModels';
import PasswordError from 'components/PasswordError';



export interface AuthResetPasswordInterface {
    handleOnPageSwitch:(key:string)=>void;
    handleOnOTPSuccess:(key:string)=>void;
    }


const AuthResetPassword = (props:AuthResetPasswordInterface) => {

    const dispatch = useDispatch();

    const {handleOnOTPSuccess} = props;


    const [countryData, setCountryData] = useState<CountryCodeData>({
        code: "+1",
        flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
      });
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    const [formErrorMessage, setFormErrorMessage] = useState<string | null>(null);
    const [isConfirmPasswordShown, setIsConfirmPasswordShown] = useState(false);


    const resetPasswordMessage = useSelector( (state: RootState) => state.auth.resetPasswordMessage );
    const resetPasswordLoading = useSelector( (state: RootState) => state.auth.resetPasswordLoading );
    const resetPasswordSuccess = useSelector( (state: RootState) => state.auth.resetPasswordSuccess );
    const userId = useSelector( (state: RootState) => state.auth.resetPasswordUser?.mobilePhone  );    

    useEffect(() => {
        if (resetPasswordSuccess && !resetPasswordLoading && formState.isSubmitted) {
            handleOnOTPSuccess('RESET_PASSWORD_SUCCESS')
        }
      }, [resetPasswordLoading]);

    const {register,errors,handleSubmit,control,getValues,setValue,watch, formState,} = useForm<any>({defaultValues: {userId:userId,confirmPassword: "",password: "",},});

    const onSubmit = (data: any) => {
        const payload = {
            mobilePhone: userId,
            sendOtp: 0,
            password: data.password,
          }
        dispatch(resetPasswordRequest(payload));
      };

  return (
    <React.Fragment>
        <div id="sign-in-screen">
            
            <form id="sign-in-form" onSubmit={handleSubmit(onSubmit)}>
               
                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label className="input-label">New Password</label>
                    <div id="signIn-text-box">
                        <input
                            style={{ fontSize: 13 }}
                            className="pwd"
                            type={isPasswordShown ? "text" : "password"}
                            name="password"
                            placeholder="Enter password"
                            autoComplete="off"
                            ref={register({
                                required: "Password is required",
                                minLength: {
                                  value: 8,
                                  message: "Password must be more than 8 characters long",
                                },
                                pattern: {
                                  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]{8,}$/,
                                  message: "Password must be alphanumeric, contain at least one uppercase letter, one special character and must not have spaces",
                                },
                              })}
                           // ref={register(validateField("password").isValidPassword().isRequired().Rules)}
                        />
                        {isPasswordShown ? (
                        <Hidepassword
                        className="hidePasswordSVG"
                        onClick={() => {
                            setIsPasswordShown(!isPasswordShown);
                        }}
                        />
                        ) : (
                        <Showpassword
                        className="showPasswordSVG"
                        onClick={() => {
                            setIsPasswordShown(!isPasswordShown);
                        }}
                        />
                        )}

                    </div>
                    <span id="error-msg">
                            {errors.password && errors.password.type === "required" && (
                                <span className="req-msg">Password Required</span>
                            )}
                            {errors.password && errors.password.type === "minLength" && (
                                <span className="req-msg">{errors.password.message}</span>
                            )}
                            {errors.password && errors.password.type === "pattern" && (
                                <PasswordError/>
                            )}
                    </span>
                </div>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label className="input-label">Confirrm Password</label>
                    <div id="signIn-text-box">
                        <input
                            style={{ fontSize: 13 }}
                            className="pwd"
                            type={isConfirmPasswordShown ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Re-enter password"
                            autoComplete="off"
                            ref={register(validateField("confirmPassword")
                            .isRequired()
                            .matchesField(
                              watch,
                              "password",
                              "",
                              "Password does not match"
                            ).Rules)}
                        />
                        {isConfirmPasswordShown ? (
                        <Hidepassword
                        className="hidePasswordSVG"
                        onClick={() => {
                            setIsConfirmPasswordShown(!isConfirmPasswordShown);
                        }}
                        />
                        ) : (
                        <Showpassword
                        className="showPasswordSVG"
                        onClick={() => {
                            setIsConfirmPasswordShown(!isConfirmPasswordShown);
                        }}
                        />
                        )}

                    </div>
                    <span id="error-msg">
                    {errors.confirmPassword &&
                        errors.confirmPassword.type == "required" && (
                        <span className="req-msg">Password Required</span>
                        )}
                    {errors.confirmPassword &&
                        errors.confirmPassword.type == "validate" && (
                        <span className="req-msg">{errors.confirmPassword.message}</span>
                        )}
                    </span>
                </div>

                <div id="links-container">

                <span className="sign-up-form-error-msg desktop-login-form-error-msg"  style={{ marginBottom: "2rem", width: "305px" }} > {resetPasswordMessage.length > 0 ? resetPasswordMessage : null} </span>
                    <button id="sign-in-button-ad"  type="submit"  style={{ width: 305 }}> 
                        {resetPasswordLoading ? "Updating" : "Done"}
                    </button>

                </div>
            </form>
        </div>
    </React.Fragment>
  )
}

export default AuthResetPassword